import { useState } from 'react';
import './App.css';

function App() {

  const [rangeValue, setRangeValue] = useState(0);  // Add this line

  let color = 'green';

  const handleRange = (e) => {
    setRangeValue(e.target.value);
  
  }

  function colorChange() {
    if (rangeValue > 50) {
      color = 'blue';
      return color
    } else {
      color = 'green';
      return color;
   }
  }

  color = colorChange();

  return (
    <div className="container">
      <h1>Slider Range Demo</h1>
     
      <div className="slider">
        <input onChange={handleRange} className='range-style' type="range" min="0" max="100" step="1" value={rangeValue} />
      </div>

      <div className="pad"></div>

      <div className="circle" style={{width: rangeValue *2 + 'px', backgroundColor : color  }}>
      <p>{rangeValue}</p>
      </div>
    </div>
  );
}

export default App;
